import React from 'react';

/**
 * ProfileInfo - 个人信息展示组件
 */
export function ProfileInfo({ profileData, onUpgrade }) {
  const isEnterprise = !!profileData?.vipLevel && profileData.vipLevel > 0;

  return (
    <div className="profile-info">
      <h2 className="profile-title profile-title-plain">个人中心</h2>
      <div className="info-list info-list-plain">
        <div className="info-item">
          <span className="info-label">姓名：</span>
          <span className="info-value info-align-right">{profileData.realName || '-'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">职位：</span>
          <span className="info-value info-align-right">{profileData.position || '-'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">企业名称：</span>
          <span className="info-value info-align-right">{profileData.company || '-'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">企业资质(附件)：</span>
          <span className="info-value info-align-right">{profileData.credentials || '无'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">手机：</span>
          <span className="info-value info-align-right">{profileData.phone || '-'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">账号类型：</span>
          <span className="info-value info-align-right">
            {isEnterprise ? '企业会员' : '个人会员'}
            {!isEnterprise && (
              <a className="upgrade-inline-link" onClick={(e) => { e.preventDefault(); onUpgrade && onUpgrade(e); }} href="#">
                <span>升级企业会员</span>
              </a>
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
